import api from "./api-manager";

const { REACT_APP_API_A39, REACT_APP_RMP_APP_ID } = process.env;

export default {
  /**
   * get lead target
   * @param {*} params
   * @returns
   */
  async getLeadTarget(params) {
    return api.post(
      `/v1/rcrm/lead-targets`,
      {},
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save setting crm to database
   * @param {*} params
   * @returns
   */
  async saveCRMSettingLeadForm(params) {
    return api.post(
      `/v1/rcrm/save-setting-fb-lead-form`,
      {
        settingId: params.settingId,
        targetType: params.targetType,
        gateId: params.gateId,
        gateName: params.gateName,
        userId: params.userId,
        userEmail: params.userEmail,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
  /**
   * save google lead setting crm to database
   * @param {*} params
   * @returns
   */
  async saveCRMGGLeadsSetting(params) {
    return api.post(
      `/v1/rcrm/save-setting-gg-lead-form`,
      {
        settingId: params.settingId,
        targetType: params.targetType,
        gateId: params.gateId,
        gateName: params.gateName,
        userId: params.userId,
        userEmail: params.userEmail,
      },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      },
    );
  },
};
